import React from 'react';
import { OperatingStatus } from '../operating-status/operating-status.tsx';
import { RestaurantDetails_getRestaurantDetails_operatingStatus } from '../../../../../types/graphql-types-generated.ts';
import { Paths } from '../../../../../utils/paths.ts';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type RestaurantMetaInfoSummaryProps = {
  restaurantDetails: {
    membershipType: string;
    averageReviewScore: number;
    reviewsCount: number;
    cuisineTranslations: { name: string; urlKey: string }[] | null;
    linkedCity: { fullnameLower: string };
    operatingStatus: RestaurantDetails_getRestaurantDetails_operatingStatus | null;
  };
  cuisineLinking?: boolean;
};

export const RestaurantMetaInfoSummary: React.FunctionComponent<
  RestaurantMetaInfoSummaryProps
> = props => {
  const { restaurantDetails, cuisineLinking } = props;
  const isPermenentlyClosed = restaurantDetails.membershipType === 'CLOSED';
  const averageReviewScore = Number(restaurantDetails.averageReviewScore?.toFixed(1)) ?? 0;
  const cuisineTranslation = restaurantDetails.cuisineTranslations?.[0];
  const divider = <div className="text-sk-grey-900 mr-2 ml-2">•</div>;

  return (
    <div className="flex text-sm">
      {averageReviewScore > 0 && (
        <>
          <div className="flex items-center">
            {averageReviewScore}
            <i className="ic-rating-small mr-0.5 ml-0.5 block text-base" />
            <span className="text-sk-grey-900">({restaurantDetails.reviewsCount})</span>
          </div>
          {divider}
        </>
      )}
      {cuisineTranslation &&
        (cuisineLinking ? (
          <>
            <a
              href={Paths.cityListingCuisine(
                restaurantDetails.linkedCity.fullnameLower,
                cuisineTranslation.urlKey
              )}
              className="hover:text-sk-red-500 flex items-center"
              onClick={() => UBTracking.trackEvent.click('restaurant_header', 'CUISINE_CITY_LINK')}
            >
              <i className="ic-kitchen-small mr-1 block text-base" />
              <span className="">{cuisineTranslation.name}</span>
            </a>
            {divider}
          </>
        ) : (
          <>
            <span className="flex items-center">
              <i className="ic-kitchen-small mr-1 block text-base" />
              <span className="">{cuisineTranslation.name}</span>
            </span>
            {divider}
          </>
        ))}
      {restaurantDetails.operatingStatus?.status && (
        <>
          <OperatingStatus
            operatingStatus={
              isPermenentlyClosed
                ? { status: 'CLOSED_PERMANENTLY', times: null }
                : restaurantDetails.operatingStatus
            }
          />
        </>
      )}
    </div>
  );
};
